// extracted by mini-css-extract-plugin
export default {"container":"VBNRuv0w6aF9ZLWhzwVY","greyBackground":"acRBO2aCG5RCzyCTlED0","hide":"jZTFD4fPoCS6PhaemNFQ"};